import React, { Component } from "react";
import ReactTable from "react-table";
import "react-table/react-table.css";
import { warning, warningNotification } from "../notification/notifications";
import { ExcelService } from "../Excel/excel";
import { LookUpService } from "../../services/lookupService";
import { PopUpPortal } from "../../containers/popups/PopUpPortal";
import loadable from "@loadable/component";
import LoadingFallback from "../loadingFallBack";
const DashboardHeader = loadable(
  () => import("../dashboardheader/dashboardheader"),
  {
    fallback: <LoadingFallback />,
  }
);

class CamsEuinReport extends Component {
  state = {
    data: [],
    pages: 0,
    loading: false,
    pageSize: 10,
    page: 0,
    apiCall: true,
    apiCall1: true,
    inboxCount: "",
    notificationEvents1: [],
    filters: {
      name: "",
      email: "",
      pan: "",
      fromDate: "",
      toDate: "",
      empNo: "",
      mobileNo: "",
      companyName: "",
      appReferenceNo: "",
      reqType: "",
      responseCode:"",
    },
  };

  fetchData = ({ page, pageSize, filtered = [] }) => {
    const filterMap = {};
    filtered.forEach(({ id, value }) => {
      filterMap[id] = value;
    });
    const {
      name,
      email,
      pan,
      fromDate,
      toDate,
      empNo,
      mobileNo,
      companyName,
      appReferenceNo,
      reqType,
      responseCode,
    } = this.state.filters;

    const params = {
      page,
      size: pageSize,
      name: filterMap.name || name,
      email: filterMap.email || email,
      pan: filterMap.pan || pan,
      empNo: filterMap.empNo || empNo,
      mobileNo: filterMap.mobileNo || mobileNo,
      companyName: filterMap.companyName || companyName,
      appReferenceNo: filterMap.appReferenceNo || appReferenceNo,
      reqType: filterMap.reqType || reqType,
      fromDate,
      toDate,
      responseCode: filterMap.responseCode || responseCode
    };

    const filteredParams = Object.fromEntries(
      Object.entries(params).filter(([_, v]) => v !== undefined && v !== null)
    );
    const queryString = new URLSearchParams(filteredParams).toString();

    this.setState({ loading: true });
    LookUpService.getCamsEuinReport(queryString, (res) => {
      if (res.status === "success") {
        this.setState({
          page,
          pageSize,
          data: res.responseListObject || [],
          pages: Math.ceil(parseInt(res.totalRecords || "0") / pageSize),
          loading: false,
        });
      } else {
        warning("Something Went wrong!", warningNotification);
        this.setState({ loading: false });
      }
    });
  };

  exportToCSV = () => {
    const {
      name,
      email,
      pan,
      fromDate,
      toDate,
      empNo,
      mobileNo,
      companyName,
      appReferenceNo,
      reqType,
      responseCode,
    } = this.state.filters;

    const params = {
      name,
      email,
      pan,
      empNo,
      mobileNo,
      companyName,
      appReferenceNo,
      reqType,
      fromDate,
      toDate,
      responseCode,
    };

    const filteredParams = Object.fromEntries(
      Object.entries(params).filter(([_, v]) => v !== undefined && v !== null)
    );
    const queryString = new URLSearchParams(filteredParams).toString();

    this.setState({ loading: true });
    let modifiedData = [];
    LookUpService.getCamsEuinReport(queryString, (res) => {
      if (res.status === "success") {
        const responseListObject = res.responseListObject || [];
        if (responseListObject.length > 0) {
          responseListObject.forEach((element, index) => {
            var data1 = {
              "Emp No": element.empNo,
              "Candidate Name": element.candidateName,
              Email: element.emailId,
              "Mobile No": element.mobileNo,
              "Company Name": element.companyName,
              PAN: element.panNumber,
              "Created Date": element.createdDate,
              "Response Code": element.responseCode,
              "Response Description": element.responseDescription,
              "App Ref No": element.appReferenceNo,
              latestStatusReferenceNo: element.latestStatusReferenceNo,
              "Req Type": element.reqType,
              "Map Reject Remarks":element.mapRejectRemarks,
            };
            modifiedData.push(data1);
          });
          console.log("modifiedData", modifiedData);
          ExcelService.ExcelData(modifiedData, "Cams-EUIN-Report");
        } else {
          warning("No record found", warningNotification);
        }
        this.setState({ loading: false });
      } else {
        warning("Something went wrong!", warningNotification);
        this.setState({ loading: false });
      }
    });
  };

  handleInputChange = (e) => {
    const { name, value } = e.target;
    this.setState((prev) => ({
      filters: {
        ...prev.filters,
        [name]: value,
      },
    }));
  };

  handleSearch = () => {
    this.fetchData({ page: 0, pageSize: 10 });
  };

  handleReset = () => {
    this.setState(
      {
        filters: {
          name: "",
          email: "",
          pan: "",
          fromDate: "",
          toDate: "",
          empNo: "",
          mobileNo: "",
          companyName: "",
          appReferenceNo: "",
          reqType: "",
          responseCode: "",
        },
      },
      () => {
        this.fetchData({ page: 0, pageSize: 10 });
      }
    );
  };

  apiCallPropsSet = (value, notificationEvents1) => {
    this.setState({ apiCall: value, notificationEvents1: notificationEvents1 });
  };
  apiCallPropsSet1 = (value, inboxCount) => {
    this.setState({ apiCall1: value, inboxCount: inboxCount });
  };

  render() {
    const columns = [
      { Header: "Emp No", accessor: "empNo" },
      { Header: "Candidate Name", accessor: "candidateName" },
      { Header: "Email", accessor: "emailId" },
      { Header: "Mobile No", accessor: "mobileNo" },
      { Header: "Company Name", accessor: "companyName" },
      { Header: "PAN", accessor: "panNumber" },
      { Header: "Created Date", accessor: "createdDate", filterable: false },
      { Header: "Response Code", accessor: "responseCode" },
      { Header: "Response Description", accessor: "responseDescription" },
      { Header: "App Ref No", accessor: "appReferenceNo" },
      {
        Header: "latestStatusReferenceNo",
        accessor: "latestStatusReferenceNo",
      },
      { Header: "Req Type", accessor: "reqType" },
      { Header: "Map Reject Remarks", accessor: "mapRejectRemarks" },
    ];

    return (
      <React.Fragment>
        <DashboardHeader
          apiCall={this.state.apiCall}
          apiCallPropsSet={this.apiCallPropsSet}
          apiCall1={this.state.apiCall1}
          apiCallPropsSet1={this.apiCallPropsSet1}
          inboxCount={this.state.inboxCount}
          notificationEvents1={this.state.notificationEvents1}
          {...this.props}
        />
        <PopUpPortal
          HidePopup={this.state.loading}
          IsVisible={this.state.loading}
        />

        <section class="dashboard-tab user-tab pt-50 mb-50">
          <div class="padding-rl-50">
            <div class="container-fluid">
              <div class="row">
                <div class="col-md-12 col-sm-12 col-xs-12">
                  <section class="updateGDPI">
                    <div class="modal-body">
                      <div class="row">
                        <div class="col-md-12 col-lg-12 col-sm-12 col-xs-12">
                          <div class="product-add">
                            <div class="form-group">
                              <div class="row">
                                <div class="col-md-4 col-sm-4 col-xs-12">
                                  <label>Emp No</label>
                                  <input
                                    type="text"
                                    name="empNo"
                                    id="empNo"
                                    autoComplete="empNo"
                                    className="form-control"
                                    placeholder="Emp No"
                                    value={this.state.filters.empNo}
                                    onChange={this.handleInputChange}
                                  />
                                </div>
                                <div class="col-md-4 col-sm-4 col-xs-12">
                                  <label>Candidate Name</label>
                                  <input
                                    type="text"
                                    name="name"
                                    id="name"
                                    autoComplete="name"
                                    className="form-control"
                                    placeholder="Candidate Name"
                                    value={this.state.filters.name}
                                    onChange={this.handleInputChange}
                                  />
                                </div>
                                <div class="col-md-4 col-sm-4 col-xs-12">
                                  <label>Email</label>
                                  <input
                                    type="text"
                                    name="email"
                                    id="email"
                                    autoComplete="email"
                                    className="form-control"
                                    placeholder="Email"
                                    value={this.state.filters.email}
                                    onChange={this.handleInputChange}
                                  />
                                </div>
                                <div class="col-md-12 col-lg-12 col-sm-12 col-xs-12"></div>
                                <div class="col-md-4 col-sm-4 col-xs-12">
                                  <label>Mobile No</label>
                                  <input
                                    type="number"
                                    name="mobileNo"
                                    id="mobileNo"
                                    autoComplete="mobileNo"
                                    className="form-control"
                                    placeholder="Mobile No"
                                    value={this.state.filters.mobileNo}
                                    onChange={this.handleInputChange}
                                  />
                                </div>
                                <div class="col-md-4 col-sm-4 col-xs-12">
                                  <label>PAN</label>
                                  <input
                                    type="text"
                                    name="pan"
                                    id="pan"
                                    autoComplete="pan"
                                    className="form-control"
                                    placeholder="PAN"
                                    value={this.state.filters.pan}
                                    onChange={this.handleInputChange}
                                  />
                                </div>
                                <div class="col-md-4 col-sm-4 col-xs-12">
                                  <label>Company Name</label>
                                  <input
                                    type="text"
                                    name="companyName"
                                    id="companyName"
                                    autoComplete="companyName"
                                    className="form-control"
                                    placeholder="Company Name"
                                    value={this.state.filters.companyName}
                                    onChange={this.handleInputChange}
                                  />
                                </div>
                                <div class="col-md-4 col-sm-4 col-xs-12">
                                  <label>App Ref No</label>
                                  <input
                                    type="text"
                                    name="appReferenceNo"
                                    id="appReferenceNo"
                                    autoComplete="appReferenceNo"
                                    className="form-control"
                                    placeholder="App Ref No"
                                    value={this.state.filters.appReferenceNo}
                                    onChange={this.handleInputChange}
                                  />
                                </div>
                                <div class="col-md-4 col-sm-4 col-xs-12">
                                  <label>Req Type</label>
                                  <input
                                    type="text"
                                    name="reqType"
                                    id="reqType"
                                    autoComplete="reqType"
                                    className="form-control"
                                    placeholder="Req Type"
                                    value={this.state.filters.reqType}
                                    onChange={this.handleInputChange}
                                  />
                                </div>
                                <div class="col-md-4 col-sm-4 col-xs-12">
                                  <label>Response Code</label>
                                  <input
                                    type="text"
                                    name="responseCode"
                                    id="responseCode"
                                    autoComplete="responseCode"
                                    className="form-control"
                                    placeholder="Response Code"
                                    value={this.state.filters.responseCode}
                                    onChange={this.handleInputChange}
                                  />
                                </div>
                                <div class="col-md-4 col-sm-4 col-xs-12">
                                  <label>From Date</label>
                                  <input
                                    type="date"
                                    name="fromDate"
                                    id="fromDate"
                                    autoComplete="fromDate"
                                    className="form-control no-after"
                                    placeholder="From Date"
                                    value={this.state.filters.fromDate}
                                    onChange={this.handleInputChange}
                                  />
                                </div>
                                <div class="col-md-4 col-sm-4 col-xs-12">
                                  <label>To Date</label>
                                  <input
                                    type="date"
                                    name="toDate"
                                    id="toDate"
                                    autoComplete="toDate"
                                    className="form-control no-after"
                                    placeholder="To Date"
                                    value={this.state.filters.toDate}
                                    onChange={this.handleInputChange}
                                  />
                                  <style>
                                    {`
                                                                        .no-after::after {
                                                                            content: none !important;
                                                                            display: none !important;
                                                                        }
                                                                        `}
                                  </style>
                                </div>
                              </div>
                            </div>
                            <div class="col-md-12 col-lg-12 col-sm-12 col-xs-12 pl pr mb-20">
                              <button
                                type="submit"
                                class="btn-4 pull-right"
                                id="search"
                                onClick={this.handleSearch}
                              >
                                Search
                              </button>
                              <button
                                type="submit"
                                class="btn-4 pull-right"
                                id="close"
                                onClick={this.handleReset}
                              >
                                Reset
                              </button>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </section>

                  <div class="table-header">
                    <h3>
                      <div class="row">
                        <div class="col-md-6 col-sm-6 col-xs-12">
                          <span class="left-icon">
                            <i class="fa fa-list" aria-hidden="true"></i>
                          </span>{" "}
                          Cams EUIN Report
                        </div>
                        <div class="col-md-6 col-sm-6 col-xs-12">
                          <span class="right-icon">
                            <a title="Export to Excel">
                              <i
                                onClick={() => this.exportToCSV()}
                                class="fa fa-file-excel-o"
                                aria-hidden="true"
                              ></i>
                            </a>
                          </span>
                        </div>
                      </div>
                    </h3>
                  </div>

                  <div class="bg-box mb-30">
                    <div class="table-responsive">
                      <ReactTable
                        className="-striped -highlight"
                        columns={columns}
                        data={this.state.data}
                        pages={this.state.pages}
                        loading={this.state.loading}
                        manual
                        // filterable
                        sortable={false}
                        minRows={2}
                        page={this.state.page}
                        pageSize={this.state.pageSize}
                        style={{
                          width: "100%",
                          maxHeight: "500px",
                        }}
                        onFetchData={({ page, pageSize, filtered }) =>
                          this.fetchData({ page, pageSize, filtered })
                        }
                      />
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>
      </React.Fragment>
    );
  }
}

export default CamsEuinReport;
